module.exports = __webpack_public_path__ + "assets/img/life.df53bff6.png";